module.exports = "\n.admin-console-button{\n    padding: 0;\n    background-color: white;\n}\n.admin-icon {\n    font-size: 17rem;\n    color: #2196f3;\n    background-color: white;\n    padding: 20px;\n}\n.admin-console-button:hover {\n    background-color: white;\n}\n.admin-console-button:hover > .admin-icon {\n    background-color: white;\n    color: #01579b  ;\n}\n.admin-button-label {\n    color: white;\n    font-size: x-large;\n    margin-top: 8%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/content/admin/admin-artists/admin-artists.component.css
// module id = ./src/app/components/dashboard/content/admin/admin-artists/admin-artists.component.css
// module chunks = main